import { render, staticRenderFns } from "./ClaimTypeSetupNew.vue?vue&type=template&id=d67f0066"
import script from "./ClaimTypeSetupNew.vue?vue&type=script&lang=js"
export * from "./ClaimTypeSetupNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports